import { createSlice } from "@reduxjs/toolkit";
import Branch from "../../models/branch.model";


interface initialStateInterface {

  branches:Array<Branch>|undefined,
  loadingBranch:boolean,
  errorBranches:any,

}

const initalState:initialStateInterface = {
  branches:undefined,
  loadingBranch:false,
  errorBranches:undefined,
}


const BranchSlice = createSlice({
  name:'branch',
  initialState:initalState,
  reducers:{
    
    fetchBranchesRequest(state){
      state.loadingBranch = true;
    },

    fetchBranchesSuccess(state,actions){
      state.loadingBranch = false;
      state.branches = actions.payload;
    },


    fetchBranchesFail(state,actions){
      state.loadingBranch = false;
      state.errorBranches = actions.payload;
    },


  }
})

export const {
  fetchBranchesFail,
  fetchBranchesRequest,
  fetchBranchesSuccess
} = BranchSlice.actions;

export default BranchSlice.reducer;